import { getToken } from "../cookie/authCookie";
import axiosInstance from "./config/axiosConfigs";



export const ReportingAPI = {

  getUserReporting: async function (userId, clubId) {

    const response = await axiosInstance.request({
      url: `/reporting/user/` + userId + '/club/' + clubId,
      method: "GET",
      withCredentials: true,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  getAllReservationEachMonth: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/admin/reporting/all/reservations/club/${clubId}`,
      method: "GET",
      withCredentials: true,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  getAllUserEachMonth: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/admin/reporting/all/users/club/${clubId}`,
      method: "GET",
      withCredentials: true,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  getAllReservationPerCourt: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/admin/reporting/all/total-reservation-per-court/club/${clubId}`,
      method: "GET",
      withCredentials: true,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  getTopTenPLayer: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/admin/reporting/all/top-ten-player/club/${clubId}`,
      method: "GET",
      withCredentials: true,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  getTotalUserByClub: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/admin/reporting/get-total-user/${clubId}`,
      method: "GET",
      withCredentials: true,
      timeout: 2000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },

  getRosterReport: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/reporting/event/excel/download/${clubId}`,
      method: "GET",
      withCredentials: true,
      responseType:'blob',
      timeout: 2000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },

  getRosterRegisteredPlayerReport: async function (eventId,clubId) {
    const response = await axiosInstance.request({
      url: `/reporting/event/${eventId}/player-info/${clubId}`,
      method: "GET",
      withCredentials: true,
      responseType: 'blob',
      timeout: 20000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  getRosterPlayerReport: async function (seasonId, coachId) {
    const response = await axiosInstance.request({
      url: `/reporting/roster/player/excel/download/${seasonId}/${coachId}`,
      method: "GET",
      withCredentials: true,
      responseType:'blob',
      timeout: 2000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  getTotalRevenueSplitByMonth: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/payment/reporting/${clubId}`,
      method: "GET",
      withCredentials: true,
      timeout: 10000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  getTotalPendingRevenueFollowedByLastMonth: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/payment/reporting/total/pending/${clubId}`,
      method: "GET",
      withCredentials: true,
      timeout: 10000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  getTotalSucceedRevenueFollowedByLastMonth: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/payment/reporting/total/succeed/${clubId}`,
      method: "GET",
      withCredentials: true,
      timeout: 10000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  getTotalMoneySpentByUserFollowedByLastMonth: async function (clubId,userId) {
    const response = await axiosInstance.request({
      url: `/payment/reporting/total/spent/${clubId}/user/${userId}`,
      method: "GET",
      withCredentials: true,
      timeout: 10000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  getTotalRevenueSplitByMonthByUser: async function (clubId,userId) {
    const response = await axiosInstance.request({
      url: `/payment/reporting/${clubId}/user/${userId}`,
      method: "GET",
      withCredentials: true,
      timeout: 10000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  getTotalPlayerFollowedByParticipantFeeAndEvent: async function (clubId,eventId) {
    const response = await axiosInstance.request({
      url: `/reporting/event/${eventId}/total-player/participant-fee/${clubId}`,
      method: "GET",
      withCredentials: true,
      timeout: 10000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  getTotalPendingAndApprovedPlayer: async function (eventId,clubId) {
    const response = await axiosInstance.request({
      url: `/reporting/event/player/status/${eventId}/club/${clubId}`,
      method: "GET",
      withCredentials: true,
      timeout: 10000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  getTotalParticipantFeeByType: async function (eventId,clubId) {
    const response = await axiosInstance.request({
      url: `/reporting/event/fee/${eventId}/club/${clubId}`,
      method: "GET",
      withCredentials: true,
      timeout: 10000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  getTotalPlayerFromClub: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/reporting/event/total/player/${clubId}`,
      method: "GET",
      withCredentials: true,
      timeout: 10000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  getTotalMemberFromClub: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/reporting/event/total/member/${clubId}`,
      method: "GET",
      withCredentials: true,
      timeout: 10000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  getTotalEventFromClub: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/reporting/event/total/${clubId}`,
      method: "GET",
      withCredentials: true,
      timeout: 10000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  getTotalJoinedEventFromClub: async function (clubId,userId) {
    const response = await axiosInstance.request({
      url: `/reporting/event/joined/total/${clubId}/user/${userId}`,
      method: "GET",
      withCredentials: true,
      timeout: 10000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  getUpcomigSchedulesFromClub: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/reporting/schedule/upcoming/${clubId}`,
      method: "GET",
      withCredentials: true,
      timeout: 10000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  getUpcomigSchedulesByUser: async function (clubId,userId) {
    const response = await axiosInstance.request({
      url: `/reporting/schedule/upcoming/${clubId}/user/${userId}`,
      method: "GET",
      withCredentials: true,
      timeout: 10000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  getPastSchedulesFromClub: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/reporting/schedule/past/${clubId}`,
      method: "GET",
      withCredentials: true,
      timeout: 10000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  getPastSchedulesByUser: async function (clubId,userId) {
    const response = await axiosInstance.request({
      url: `/reporting/schedule/past/${clubId}/user/${userId}`,
      method: "GET",
      withCredentials: true,
      timeout: 10000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  getTotalPlayerFollowedByEvent: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/reporting/event/total-player/${clubId}`,
      method: "GET",
      withCredentials: true,
      timeout: 10000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },





};